import React, { useState, useEffect, useContext } from 'react';
import { string, bool, shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { initImpressionWatchers } from '../../utils/initImpressionWatchers';
import { makeApiRequest, shouldMakeApiRequest } from '../../utils/requestHelpers';
import { getSchema, getSkus, isExperienceDataResolved } from '../../utils/helpers';
import styles from './SponsoredSkyscraperBanner.module.scss';

const isValidScenario = ({
  schemaId, lastRequestScenario, experienceContext, pageContext, customRenderId
}) => {

  if (schemaId.includes('event_browse_sponsored')) {

    return false;
  }

  return shouldMakeApiRequest({
    lastRequestScenario,
    experienceContext,
    pageContext,
    customRenderId
  });
};

const SponsoredSkyscraperBannerComponent = (props) => {
  const [lastRequestScenario, setLastRequestScenario] = useState({});
  const [hasData, setHasData] = useState(false);
  const experienceContext = useContext(ExperienceContext);
  const { pageContext, customRenderId, categoryId, slugId } = props;
  let { schema } = props;
  const cx = classNames.bind(styles);
  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true,
  });

  experienceContext.useStoreId = storeId;

  schema = getSchema({ schema, pageContext });
  const schemaId = schema + '__skyscraper';

  useEffect(() => {
    const isResolvedContext = isExperienceDataResolved({ isLocalized, experienceContext });

    if (
      isResolvedContext
      && isValidScenario({
        schemaId, lastRequestScenario, experienceContext, pageContext, customRenderId
      })
    ) {
      setLastRequestScenario({
        url: window.location.pathname + window.location.search,
        skus: getSkus(pageContext),
      });

      makeApiRequest({
        schema,
        schemaId,
        experienceContext,
        pageContext,
        setHasData,
        bannerType: 'skyscraper',
        categoryId,
        slugId
      });
    }

  }, [pageContext?.data, isLocalized, experienceContext.mounted, categoryId, schema, slugId]);

  useEffect(() => {
    initImpressionWatchers();
  }, [hasData]);

  if (!hasData) {
    return null;
  }

  return (
    <div id="sponsored-skyscraper-banner" className={cx('sponsored_skyscraper_banner')}>
      <div id={schemaId} data-testid="sponsored-skyscraper-banner" />
    </div>
  );
};

SponsoredSkyscraperBannerComponent.propTypes = {
  categoryId: string,
  customRenderId: string,
  schema: string,
  slugId: string,
  pageContext: shape({
    label: string,
    data: shape(),
    keyword: string,
    isSearch: bool,
    isCategory: bool,
    isBrowse: bool,
  }),
};

SponsoredSkyscraperBannerComponent.defaultProps = {
  categoryId: '',
  customRenderId: '',
  schema: '',
  slugId: '',
  pageContext: {},
};

const SponsoredSkyscraperBanner = withDynamicComponent(
  withHydrator(
    {
      id: 'sponsored-skyscraper-banner',
      preserveCtxVal: 'clientStore'
    },
    SponsoredSkyscraperBannerComponent
  )
);

export { SponsoredSkyscraperBanner };
